exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-3QZLD{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.container-3QZLD.inline-1yth1{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.textareaLabel-xrm7Q{position:absolute;left:0;font-size:.8rem;font-weight:600}.textareaField-2Azd7{margin-top:20px}.requireMessage-3JsKg{position:absolute;right:0;padding:2px 10px;background-color:#0a81ff;text-transform:uppercase;font-size:9px}.light-3JYho{background-color:#fff}.theme-dark .requireMessage-3JsKg{background-color:#0a81ff}.theme-dark .light-3JYho{background-color:#fff}.theme-light .requireMessage-3JsKg{background-color:#0a81ff}.theme-light .light-3JYho{background-color:#eaf6ff}", ""]);

// exports
exports.locals = {
	"container": "container-3QZLD",
	"inline": "inline-1yth1",
	"textareaLabel": "textareaLabel-xrm7Q",
	"textareaField": "textareaField-2Azd7",
	"requireMessage": "requireMessage-3JsKg",
	"light": "light-3JYho"
};